import { useRoute } from 'vue-router'
import { defineStore } from 'pinia'
import { useFetch } from '@/modules/core/composables/useFetch'
import { Check, SearchParams, SearchResult } from '../types'

export const useCheckStore = defineStore('screening/checkStore', () => {
  const { slug } = useRoute().params as { slug: string }
  const baseUrl = `/v4/${slug}/screening/checks`

  // queries

  const fetchCheck = async (check_id: number | string) => {
    return await useFetch(`${baseUrl}/${check_id}`).get<Check>()
  }

  // commands

  const dismissFalsePositive = async (check_id: number | string, note: string) => {
    await useFetch(`${baseUrl}/${check_id}/dismiss-false-positive`).post({ note })
  }

  const confirmMatch = async (check_id: number | string, note: string) => {
    await useFetch(`${baseUrl}/${check_id}/confirm-match`).post({ note })
  }

  // helpers

  const isReviewable = (check: Check) => {
    return ['pending_review', 'false_positive', 'confirmed_match'].includes(check?.status)
  }

  const isReviewed = (check: Check) => ['confirmed_match', 'false_positive'].includes(check?.status)

  const searchParams = (check: Check): SearchParams => check?.raw_search_response?.search?.params

  const searchResults = (check: Check): SearchResult[] => check?.raw_search_response?.results

  return {
    fetchCheck,
    dismissFalsePositive,
    confirmMatch,

    isReviewable,
    isReviewed,
    searchParams,
    searchResults,
  }
})
